import { makeBlobPostRequest, makeGetRequest, makePostRequest, makePutRequest, urlsPath } from "./restServices"
import { CreatePatientType, CreateUserType, GetPatientsTreatmentsType, PostLoginType, PostPersonalInfoType, PostSetNewPasswordType } from "./apiBodyTypes"
import { DateRange } from "react-day-picker"

// let otpToken: string | null
let token: string | undefined


async function getDashboardData(
  creationDateRange: DateRange | undefined,
  filters: string[] = []
): Promise<{ success: boolean; data: any }> {
  try {
    const dashboardRes = await makePostRequest(`dashboard`, {
      creationDateRange,
      filters,
    });
    if (dashboardRes.data.success) {
      return { success: true, data: dashboardRes.data.data };
    }
    return { success: false, data: {} };
  } catch (err) {
    console.log("Error fetching dashboard data:", err);
    return { success: false, data: {} };
  }
}

async function exportDashboardData(): Promise<Blob> {
    return await makeBlobPostRequest("dashboard/export", {});
}


//##################### TREATMENTS #####################//
async function getPatientsTreatments(body: GetPatientsTreatmentsType) {
    try {
        const treatmentsRes = await makePostRequest(`treatment/get-patient-treatments`,
            { sortKey: body.sortKey, sortOrder: body.sortOrder, creationDateRange: body.creationDateRange, patientId: body.patientId }
        )
        if (treatmentsRes.data.success)
            return treatmentsRes.data.data
    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}


//##################### USERS #####################//
async function postLogin(body: PostLoginType): Promise<{
  success: boolean;
  data?: { access_token?: string; needOtp: boolean; role?: string };
  err?: any;
}> {
  try {
    const res = await makePostRequest("/users/Login", body);
    if (!res.data.success) throw { error: "error" };
    return { success: true, data: res.data.data };
  } catch (err: any) {
    console.log("err", err);
    return {
      success: false,
      err: err?.response?.data.message || "Login Failed",
    };
  }
}
async function createUser(body: CreateUserType): Promise<{ success: boolean, data?: { errorMessage?: string }, err?: any }> {
    try {
        const res = await makePostRequest("/users/create-user", body)
        if (res.data.success) {
            return { success: true, data: {} }
        } else {
            return {
                success: false, data: { errorMessage: res.data.errorMessage }
            }
        }
    }
    catch (err: any) {
        return { success: false, data: { errorMessage: err?.response?.data.message || "User creation failed" } }
    }
}
async function updateUser(body: CreateUserType): Promise<{ success: boolean, data?: {}, err?: any }> {
    try {
        const res = await makePostRequest("/users/update-user", body)
        if (!res.data.success)
            throw { error: "error" }
        return { success: true, data: {} }

    } catch (err: any) {
        console.log("err", err)
        return { success: false, err: err?.response?.data.message || "Login Failed" }
    }
}


async function postPersonalInfo(body: PostPersonalInfoType): Promise<{ success: boolean, data: {} }> {
    try {

        const res = await makePostRequest("/user-info/set-user-info", body)
        if (res.data.success)
            token = res.data.data.access_token
        return { success: true, data: {} }

    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}

async function postSetFirstPassword(body: PostSetNewPasswordType): Promise<{ success: boolean, data: {} }> {
    try {

        const res = await makePostRequest("/users/first-login-change-password", body)
        //catch if token expired. if so refresh token
        return { success: true, data: {} }

    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}
async function updatePassword(body: PostSetNewPasswordType): Promise<any> {
    try {
        const res = await makePutRequest("/users/update-password", body)
        if (res.data.success)
            return { success: true, data: {} }
    }
    catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}

async function getUserInfo() {
    try {
        const user = await makeGetRequest("users/get-user-by-token")
        return user.data
    }
    catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}

async function getAllUsers(sortKey: string, sortOrder: string, search: string, filters: string[]) {
    try {
        const patients = await makePostRequest(`users/get-all-users`, { sortKey, sortOrder, search, filters })
        if (patients.data.success)
            return patients.data.data
    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}
async function exportUsers(body: any): Promise<Blob> {
    return await makeBlobPostRequest("users/export", body);
}
async function exportCenters(body: any): Promise<Blob> {
  return await makeBlobPostRequest("site/export", body);
}
async function exportPatients(body: any): Promise<Blob> {
  return await makeBlobPostRequest("patients/export", body);
}
async function getUserCardsData() {
  try {
    const userCards = await makeGetRequest(`users/get-user-cards-data`);
    if (userCards.data.success) return userCards.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}
async function getCenterCardsData() {
  try {
    const userCards = await makeGetRequest(`users/get-center-cards-data`);
    if (userCards.data.success) return userCards.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}
async function getDeviceCardsData() {
  try {
    const userCards = await makeGetRequest(`device/get-device-cards-data`);
    if (userCards.data.success) return userCards.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}

async function getAllHCPs() {
  try {
    const userCards = await makeGetRequest(`users/get-all-hcp`);
    if (userCards.data.success) return userCards.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}

//##################### PATIENTS #####################//
async function getAllBranchPatients(sortKey: string, sortOrder: string) {
  try {
    const patients = await makePostRequest(`patients/get-all-site-patients`, {
      sortKey,
      sortOrder,
    });
    if (patients.data.success) return patients.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}
async function getAllPatients(
  sortKey: string,
  sortOrder: string,
  search: string,
  filters: string[],
  creationDateRange: DateRange | undefined
) {
  try {
    const patients = await makePostRequest(`patients/get-all-patients`, {
      sortKey,
      sortOrder,
      search,
      filters,
      creationDateRange,
    });
    if (patients.data.success) return patients.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}

// async function createPatient(body: CreatePatientType): Promise<{ success: boolean, data?: {}, err?: any }> {
//     try {
//         const res = await makePostRequest("/users/create-user", body)
//         if (!res.data.success)
//             throw { error: "error" }
//         return { success: true, data: {} }

//     } catch (err: any) {
//         console.log("err", err)
//         return { success: false, err: err?.response?.data.message || "Login Failed" }
//     }
// }

async function getPatientsCardsData() {
  try {
    const userCards = await makeGetRequest(`patients/get-patients-cards-data`);
    if (userCards.data.success) return userCards.data.data;
  } catch (err) {
    console.log("err", err);
    return { success: false, data: {} };
  }
}

async function updatePatient(
  body: CreatePatientType
): Promise<{ success: boolean; data?: {}; err?: any }> {
  try {
    const res = await makePostRequest("/patients/update-patients", body);
    if (!res.data.success) throw { error: "error" };
    return { success: true, data: {} };
  } catch (err: any) {
    console.log("err", err);
    return {
      success: false,
      err: err?.response?.data.message || "Login Failed",
    };
  }
}
async function forgetPassword(email: string) {
  try {
    const res = await makePostRequest(urlsPath + "/users/forgot-password", {
      email,
    });
    if (res.data.success) return { success: true, data: {} };
  } catch (err) {
    return {
      success: false,
      data: { errorMessage: {} },
    };
  }
}
async function postResetOtp(code: string) {
  try {
    const res = await makePostRequest("/users/validate-reset-password-otp", {
      code,
    });
    if (!res.data.success) throw new Error(res.data.error);
    return {
      success: true,
      data: {},
    };
  } catch (err) {
    return { success: false, data: { errorMessage: {} } };
  }
}
async function getTermsAndConditions() {
  try {
    const res = await makeGetRequest("/getTermsAndConditions");
    const contentType = (res.headers?.["content-type"] || "").toString();
    if (contentType.includes("text/html")) {
      return { success: true, data: res.data };
    }
    if (res.data?.success) {
      return { success: true, data: res.data.data };
    }
    return { success: false, data: { errorMessage: "Unexpected response" } };
  } catch (err) {
    return {
      success: false,
      data: { errorMessage: "Failed to load terms and conditions" },
    };
  }
}
async function getPrivacyPolicy() {
  try {
    const res = await makeGetRequest("/getPrivacyPolicy");
    const contentType = (res.headers?.["content-type"] || "").toString();
    if (contentType.includes("text/html")) {
      return { success: true, data: res.data };
    }
    if (res.data?.success) {
      return { success: true, data: res.data.data };
    }
    return { success: false, data: { errorMessage: "Unexpected response" } };
  } catch (err) {
    return {
      success: false,
      data: { errorMessage: "Failed to load privacy policy" },
    };
  }
}

export {
  postLogin,
  postSetFirstPassword,
  postPersonalInfo,
  getUserInfo,
  getAllBranchPatients,
  createUser,
  getAllUsers,
  getUserCardsData,
  updateUser,
  getAllPatients,
  getPatientsCardsData,
  getDashboardData,
  getPatientsTreatments,
  getAllHCPs,
  updatePatient,
  exportUsers,
  exportDashboardData,
  forgetPassword,
  postResetOtp,
  getTermsAndConditions,
  updatePassword,
  getDeviceCardsData,
  getCenterCardsData,
  getPrivacyPolicy,
  exportCenters,
  exportPatients,
};